import React, { useEffect, useRef } from "react";
import { SmetaSplitterItemProps } from "./SmetaSplitterConsts";
import { useSplitterItem } from "./SmetaSplitterContext";

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function SmetaSplitterItem(props: SmetaSplitterItemProps) {
  const propertyChangedHandler = useSplitterItem();
  const prevProps = useRef({
    size: props.size,
    min: props.min,
    max: props.max,
    collapsed: props.collapsed,
  });

  useEffect(() => {
    const keys = ["collapsed", "max", "min", "size"] as const;
    for (const key of keys) {
      if (prevProps.current[key] !== props[key]) {
        propertyChangedHandler(key, prevProps.current[key], props[key]);
        prevProps.current[key] = props[key];
      }
    }
  }, [props.collapsed, props.max, props.min, props.size]);

  return <>{props.children}</>;
}
